import actions from './actions';

const initState = {
	dataMultipleChoiceMultipleAnswer: [],
	multipleChoiceMultipleAnswerDetail: {},
	totalItems: 0,
	loading: false,
};

export default function multipleChoiceMultipleAnswerReducer(state = initState, action) {
	switch (action.type) {
		case actions.GET_MULTIPLE_CHOICE_MULTIPLE_ANSWER:
			return { ...state, totalItems: 0, loading: true };
		case actions.GET_MULTIPLE_CHOICE_MULTIPLE_ANSWER_SUCCESS:
			let { data, totalItems } = action.payload;
			let res = data ? data : [];
			return { ...state, dataMultipleChoiceMultipleAnswer: res, totalItems, loading: false };

		case actions.GET_MULTIPLE_CHOICE_MULTIPLE_ANSWER_DETAIL:
			return { ...state, loading: true, totalItems: 0 };
		case actions.GET_MULTIPLE_CHOICE_MULTIPLE_ANSWER_DETAIL_SUCCESS: {
			let { data } = action.payload;
			let res = data ? data : {};
			return { ...state, multipleChoiceMultipleAnswerDetail: res, loading: false };
		}

		case actions.LISTENING_LOADING_FALSE: {
			return { ...state, loading: false };
		}

		default:
			return state;
	}
}
